// extracted by css-extract-rspack-plugin
export default {"packageLabelContainer":"ux34SPcdlVgzxpbU","packageLabelText":"UNVxzmYUQ84CGm_J","packageLabelOptionsSelect":"QLtZ8T7Y0vIaSH8I"};